import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('pagamento_verbas_estruturais', 'gestao');

const pagamentoGestaoActions = {
  competencias: { method: 'GET', url: `${basePath}/competencias` },
  aprovados: { method: 'GET', url: `${basePath}/aprovados` },
  pendente: { method: 'GET', url: `${basePath}/pendente_integracao` },
  agPagamento: { method: 'GET', url: `${basePath}/aguardando_pagamento` },
  liquidados: { method: 'GET', url: `${basePath}/liquidados` },
  naoLiquidados: { method: 'GET', url: `${basePath}/nao_liquidados` },
  bloqueados: { method: 'GET', url: `${basePath}/bloqueados` },
  resgatar: { method: 'PUT', url: `${basePath}/resgatar/{idPagamento}` },
  exportar: { method: 'PUT', url: `${basePath}/status/aguardando_pagamento` },
  cancelar: { method: 'POST', url: `${basePath}/cancelamento` },
  resgatarPagamentos: { method: 'POST', url: `${basePath}/resgate` },
  cancelarUnico: { method: 'DELETE', url: `${basePath}/{id}` },
};

export default resource => resource(`${basePath}`, {}, pagamentoGestaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/pagamento-gestao.js